export const GRADIENT_TITLE_COLORS = [
	'#34d399',
	'#10b981',
	'#059669',
	'#06b6d4',
	'#34d399',
];

export const GRADIENT_BACKGROUND_CLASS =
	'bg-gradient-to-br from-emerald-400 via-green-500 to-teal-600';

export const GRADIENT_CONTACT_METHODS = 'from-green-100 to-emerald-100';

export const GRADIENT_HEADER =
	'from-green-500 to-green-700 hover:from-green-600 hover:to-green-800';

export const GRADIENT_HERO = 'from-green-600 to-green-800';
